export const OrgDeviceDetailsTestIds = {
  deviceCardHeader: 'deviceCard_header',
  deviceCardNumber: 'deviceCard_number',
  deviceCardHeaderName: 'deviceCard_header_name',
  deviceCardBody1: 'deviceCard_body1',
  deviceCardIpValue: 'deviceCard_ipValue',
  deviceCardDeviceIdValue: 'deviceCard_deviceIdValue',
  dividerTitle: 'divider_title',
  deviceCardBody2: 'deviceCard_body2',
  deviceCardLastSeenValue: 'deviceCard_lastSeenValue',
  deleteAllBtn: 'delete_all_btn',
  deviceCardButtonDelete: 'deviceCard_button_delete'
} as const;
